import { render, staticRenderFns } from "./FlowStep.vue?vue&type=template&id=36abc786&scoped=true"
import script from "./FlowStep.vue?vue&type=script&lang=js"
export * from "./FlowStep.vue?vue&type=script&lang=js"
import style0 from "./FlowStep.vue?vue&type=style&index=0&id=36abc786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36abc786",
  null
  
)

export default component.exports